import { generateRegion } from './city';
import { expandRegion } from './region';
import { upgradeRoads } from './roads';
import { prepareAirport } from './airport';
import { prepareCoastParcels, prepareCoastAmenities } from './coast';
import { prepareLivingDistrict } from './interiors';
import { prepareFacilities } from './facilities';
import { prepareRail } from './rail';
import { prepareRailBranches } from './rail-branches';
import { prepareHelipads } from './helipads';
import { prepareStreetTransit } from './street-transit';
import { prepareLogistics } from './logistics';
import { prepareDutyRooms } from './duty-rooms';
import { prepareTerrain } from './terrain';
import { prepareMarina } from './marina';
import { prepareHabitats } from './habitats';
import { prepareLandscape } from './landscape';
import { prepareTallLandmarks } from './landmarks';
import { prepareStrategicDistricts, prepareStrategicDuties } from './strategic-districts';
import { prepareStrategicTransport } from './strategic-transport';
import { prepareStreetCity } from './street-city';

/** One ordered production assembly, also used by integrated access checks. */
export function createLivingCity(
  seed = 73421,
  options: { towerTrial?: boolean; strategicTrial?: boolean; streetLife?: boolean; lite?: boolean } = {},
) {
  const city = generateRegion(seed);
  if (options.towerTrial) prepareTallLandmarks(city, options.streetLife ? 1 : 6);
  if (options.lite) {
    // The same downtown, houses, bridge and live service machinery, without
    // generating the outer city, military roster or scheduled transport fleets.
    upgradeRoads(city);
    prepareLivingDistrict(city);
    prepareFacilities(city);
    city.regional = true;
    city.logicalPopulation = 180;
    city.ordinaryTraffic = 48;
    prepareAirport(city);
    prepareDutyRooms(city);
    prepareTerrain(city);
    prepareStreetCity(city);
    return city;
  }
  expandRegion(city);
  upgradeRoads(city);
  prepareAirport(city);
  if (options.strategicTrial) prepareStrategicDistricts(city);
  prepareCoastParcels(city);
  prepareLivingDistrict(city);
  prepareFacilities(city);
  prepareRail(city);
  prepareRailBranches(city);
  prepareHelipads(city);
  prepareStreetTransit(city);
  prepareLogistics(city);
  prepareDutyRooms(city);
  prepareStrategicDuties(city);
  prepareCoastAmenities(city);
  prepareMarina(city);
  prepareHabitats(city);
  prepareLandscape(prepareStrategicTransport(prepareTerrain(city)));
  if (options.streetLife) prepareStreetCity(city);
  return city;
}
